import { Box, Grid, styled } from '@mui/material';
import { FIXED_FOOTER_HEIGHT, STEPPER_HEADER_HEIGHT } from 'src/constants';

export const StepContentWrapper = styled(Box)(
  ({ theme }) => `
  border-top: 1px solid ${theme.palette.secondary.lightest};
  height: calc(100vh - ${STEPPER_HEADER_HEIGHT}px - ${FIXED_FOOTER_HEIGHT}px - 20px);
  overflow: hidden;
  margin-left: -30px;
  margin-right: -30px;
`,
);

export const StepContentContainer = styled(Grid)`
  height: 100%;
  margin-top: 0;
`;
